import {
  Paper,
  Zoom,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './PaperSheetError.scss';

/**
 * Paper sheet to display error message
 *
 * Props:
 * message - message to display
 */
const defaultProps = {
  message: '',
  className: '',
};
export default function PaperSheetError(props) {
  const { message, className, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <Zoom timeout={500} in>
      <div className={`PaperSheetError ${className}`}>
        <Paper {...rest} className='paper-sheet paper-sheet-error'>
          <Typography component='p'>
            {message}
          </Typography>
        </Paper>
      </div>
    </Zoom>
  );
}
